import { STORAGE_KEYS } from '@/constants/storage'

export interface ImpersonationStorageData {
  token: string
  expiresAt: string
  studioId: number
  studioName: string
  adminToken: string
  returnPath: string
}

export const isImpersonationExpired = (expiresAt: string | null | undefined): boolean => {
  if (!expiresAt) return true
  const ms = Date.parse(expiresAt)
  if (Number.isNaN(ms)) return true
  return ms <= Date.now()
}

export const readImpersonationStorage = (): ImpersonationStorageData | null => {
  const token = localStorage.getItem(STORAGE_KEYS.impersonationToken)
  const expiresAt = localStorage.getItem(STORAGE_KEYS.impersonationExpiresAt)
  const studioIdRaw = localStorage.getItem(STORAGE_KEYS.impersonationStudioId)
  const studioName = localStorage.getItem(STORAGE_KEYS.impersonationStudioName)
  const adminToken = localStorage.getItem(STORAGE_KEYS.impersonationAdminToken)
  const returnPath = localStorage.getItem(STORAGE_KEYS.impersonationReturnPath)

  if (!token || !expiresAt || !studioIdRaw || !studioName || !adminToken) return null
  const studioId = Number(studioIdRaw)
  if (!Number.isFinite(studioId) || studioId <= 0) return null

  return {
    token,
    expiresAt,
    studioId,
    studioName,
    adminToken,
    returnPath: returnPath || `/admin/studios/${studioId}`,
  }
}

export const clearImpersonationStorage = (): void => {
  localStorage.removeItem(STORAGE_KEYS.impersonationToken)
  localStorage.removeItem(STORAGE_KEYS.impersonationExpiresAt)
  localStorage.removeItem(STORAGE_KEYS.impersonationStudioId)
  localStorage.removeItem(STORAGE_KEYS.impersonationStudioName)
  localStorage.removeItem(STORAGE_KEYS.impersonationAdminToken)
  localStorage.removeItem(STORAGE_KEYS.impersonationReturnPath)
}

export const persistImpersonationStorage = (payload: ImpersonationStorageData): void => {
  localStorage.setItem(STORAGE_KEYS.impersonationToken, payload.token)
  localStorage.setItem(STORAGE_KEYS.impersonationExpiresAt, payload.expiresAt)
  localStorage.setItem(STORAGE_KEYS.impersonationStudioId, String(payload.studioId))
  localStorage.setItem(STORAGE_KEYS.impersonationStudioName, payload.studioName)
  localStorage.setItem(STORAGE_KEYS.impersonationAdminToken, payload.adminToken)
  localStorage.setItem(STORAGE_KEYS.impersonationReturnPath, payload.returnPath)
  localStorage.setItem(STORAGE_KEYS.token, payload.token)
}

export const restoreAdminTokenFromImpersonation = (): string | null => {
  const stored = readImpersonationStorage()
  const adminToken = stored?.adminToken ?? localStorage.getItem(STORAGE_KEYS.impersonationAdminToken)
  if (!adminToken) return null
  localStorage.setItem(STORAGE_KEYS.token, adminToken)
  return adminToken
}
